import React, { Component } from 'react'
import Promise from 'bluebird'
import config from 'cfg'
import styled from 'styled-components'
import CopyToClipboard from 'react-copy-to-clipboard'
import { List, ListItem, Divider, FlatButton, Snackbar } from 'material-ui'
import ContentCopy from 'material-ui/svg-icons/content/content-copy'
import moment from 'moment'

const TeamPlayers = styled.div`
    margin: 0 auto 10px;
    max-width: 1170px;
    
    .id {
        min-width: 120px;
        text-align: center;
    }
    
    .list-item {
        border-left: 1px solid #E0E0E0;
        border-right: 1px solid #E0E0E0;  
        > div > div {
          display: flex !important;
          span {
            flex: 0 1 50%;
            &.id {
                flex: 0 1 30%;
                text-align: right;
              }
          }
        }
        span {
          font-size: .875rem;   
          i {
            font-style: normal;
            display: inline-block;
            min-width: 20px;
          }
        }
    }
`;
const Coach = styled.div`
    margin-bottom: 20px;
    font-size: .875rem;   
`;

const playersPositions = ['keeper', 'defender', 'midfielder', 'forward'];

export default class IDSTeam extends Component {
    state = {
        team: null,
        open: false
    };

    componentDidMount() {
        const teamId = this.props.params.teamId;

        Promise.props({
            team: fetch(`${config.apis.ss2}/teams/${teamId}/profile`).then(response => response.json())

        }).then(res => {
            this.setState({
                team: res.team
            });

        });
    }

    render() {
        const { team } = this.state;

        if (!team) return null;

        return (
            <TeamPlayers>
                {this.renderPlayers()}
                {this.renderUpcomingEvents()}
                {this.renderFinishedEvents()}
            </TeamPlayers>
        );
    }

    getCoach() {
        const { team } = this.state;

        if (!team.members || !team.members.coach) return null;

        const coachName = team.members.coach[0].name;

        return <Coach>Coach: <b>{coachName}</b></Coach>;
    };

    renderPlayers() {
        const { team } = this.state;

        if (!team || !team.members) return <div style={{textAlign: 'center'}}>no team information available</div>;

        const btnsPositioning = {
            right: 0,
            marginRight: 16,
            position: 'absolute',
            transform: 'translateY(-50%)',
            top: '50%'
        };

        const snackbarStyle = {
            textAlign: 'center'
        };

        let sortedPlayers = playersPositions.map(position => {
            return team.members.players.filter(plr => {
                return plr.position === position;
            });
        });

        let players = sortedPlayers.map(player => {
            return player.map(plr => {
                return (
                    <div className='list-item' key={plr.id}>
                        <ListItem disabled={true}>
                            <span><i>{plr.number || '-'}</i> {plr.name}</span>
                            <span className='id'>{plr.id}</span>
                            <CopyToClipboard text={plr.id}>
                                <div>
                                    <FlatButton
                                        label="Copy"
                                        primary={true}
                                        icon={<ContentCopy />}
                                        onClick={this.handleTouchTap}
                                        style={btnsPositioning}
                                    />
                                    <Snackbar
                                        open={this.state.open}
                                        message='ID copied to clipboard'
                                        autoHideDuration={3000}
                                        onRequestClose={this.handleRequestClose}
                                        contentStyle={snackbarStyle}
                                    />
                                </div>
                            </CopyToClipboard>
                        </ListItem>
                        <Divider/>
                    </div>
                )
            });
        });

        return (
            <div>
                <h1>{team.name}</h1>
                <h3>Players</h3>
                <div>{this.getCoach()}</div>
                <List>
                    <Divider/>
                    {players}
                </List>
            </div>
        );
    };

    renderUpcomingEvents() {
        const { team } = this.state;

        return (
            <div>
                <h3>Upcoming events</h3>
                {this.getEvents(team.upcomingEvents)}
            </div>
        );
    };

    renderFinishedEvents() {
        const { team } = this.state;

        return (
            <div>
                <h3>Finished events</h3>
                {this.getEvents(team.finishedEvents)}
            </div>
        );
    };

    getEvents(event) {
        const { team } = this.state;

        if (!team || !event) return null;

        const btnsPositioning = {
            right: 0,
            marginRight: 16,
            position: 'absolute',
            transform: 'translateY(-50%)',
            top: '50%'
        };
        const snackbarStyle = {
            textAlign: 'center'
        };
        const spanStyle = {
            flex: '0 1 calc(100% / 3)'
        };

        let eventsList = event.map((ev, i) => {
            let date = moment(ev.startDate).format('DD. MMM. YYYY - HH:mm');

            return (
                <div key={i} className='list-item'>
                    <ListItem disabled={true}>
                        <span style={spanStyle}>{date}</span>
                        <span style={spanStyle}>{ev.homeName} &ndash; {ev.awayName}</span>
                        <span style={spanStyle}>{ev.statusType === "finished" ? `${ev.score.home} - ${ev.score.away}` : null}</span>
                        <span style={spanStyle}>{ev.eventId}</span>
                        <CopyToClipboard text={ev.eventId}>
                            <div>
                                <FlatButton
                                    label="Copy"
                                    primary={true}
                                    icon={<ContentCopy />}
                                    onClick={this.handleTouchTap}
                                    style={btnsPositioning}
                                />
                                <Snackbar
                                    open={this.state.open}
                                    message='ID copied to clipboard'
                                    autoHideDuration={3000}
                                    onRequestClose={this.handleRequestClose}
                                    contentStyle={snackbarStyle}
                                />
                            </div>
                        </CopyToClipboard>
                    </ListItem>
                    <Divider/>
                </div>
            );
        });

        return (
            <List>
                <Divider/>
                {eventsList}
            </List>
        );

    };

    handleTouchTap = () => {
        this.setState({
            open: true
        });
    };

    handleRequestClose = () => {
        this.setState({
            open: false
        });
    };
}


/** WEBPACK FOOTER **
 ** ../src/dash/front/components/ids-finder/IDSTeam.js
 **/